module.exports = __webpack_public_path__ + "img/h1-2.ebbab4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/honor_system/h1-2.png
// module id = Zlsx
// module chunks = 15